                                


    








    // ******************************************************
    // CAROUSEL                   
    // ******************************************************
    

    // init *** 
    let fCarouselDone = true;
    let thumbnailCarPosition = 0;
    let featThumbDistance = 110;
    let featCarMaxIndex = 0;


    // set max index *** 
    $(window).on("resize", function() {
        featCarMaxIndex = getFeatCarMaxIndex();
        if (thumbnailCarPosition > featCarMaxIndex) {
            thumbnailCarPosition = featCarMaxIndex;
            moveThumbnailCarousel();
        }
    }).trigger("resize");


    // handle image change ***
    $("#FeaturedImgControls .fcontrol").click(function() {
        if (!fCarouselDone) return;
        let $thumb = $(this);
        let $outer = $("#FeaturedImgControls");
        let outerRect = $outer[0].getBoundingClientRect();
        let thumbRect = $thumb[0].getBoundingClientRect();
        let edgeTolerance = 8;
        let canMoveUp = thumbnailCarPosition > 0;
        let canMoveDown = thumbnailCarPosition < featCarMaxIndex;
        let isAboveView = thumbRect.top < outerRect.top;
        let isBelowView = thumbRect.bottom > outerRect.bottom;
        let isAtTopEdge = canMoveUp && Math.abs(thumbRect.top - outerRect.top) <= edgeTolerance;
        let isAtBottomEdge = canMoveDown && Math.abs(thumbRect.bottom - outerRect.bottom) <= edgeTolerance;
        if ((isAboveView || isAtTopEdge) && canMoveUp) {
            thumbnailCarPosition--;
            moveThumbnailCarousel();
        }
        else if ((isBelowView || isAtBottomEdge) && canMoveDown) {
            thumbnailCarPosition++;
            moveThumbnailCarousel();
        }
        if (!$thumb.hasClass("active")) {
            fCarDoneUtil();
            $("#FeaturedImgControls .fcontrol.active").removeClass("active");
            $thumb.addClass("active");
            let activeCarNum = $thumb.attr("data-num");
            let $currentImg = $("#FeaturedImg .fimg.active");
            let $nextImg = $("#FeaturedImg .fimg.fi" + activeCarNum);
            $currentImg.removeClass("active");
            $nextImg.addClass("active");
        }
    });


    // move helper ***
    function moveThumbnailCarousel() {
        $("#FeaturedControlsCarouselInner").css({
            "top": ((thumbnailCarPosition * featThumbDistance) * -1)
        });
    }


    // max index helper *** 
    function getFeatCarMaxIndex() {
        let totalThumbs = $("#FeaturedControlsCarouselInner .fcontrol").length;
        let visibleThumbs = Math.floor($("#FeaturedImgControls").outerHeight() / featThumbDistance);
        return Math.max(0, totalThumbs - visibleThumbs);
    }


    // done helper ***  
    function fCarDoneUtil() {
        fCarouselDone = false;
        setTimeout(function() {
            fCarouselDone = true;
        }, 500);
    }  












    // ******************************************************
    // PRODUCT INFO AREA                    
    // ******************************************************


    // init ***
    let currentFeaturedQty = 1;




    // set product content position ***
    $(window).on("resize", function() {
        let margin; 
        let imgH = $("#FeaturedImg").height();
        let contH = $("#FeaturedContent").height();
        if (contH > imgH) { 
            margin = 0; 
        }
        else {
            margin = (imgH - contH) / 2;
        }
        $("#FeaturedContent").css({"margin-top": margin + "px"});  
    }).resize();




    // change active variant ***
    $("#VariantDropDown h5").click(function() { 

        // init 
        let el = $(this);

        // set active variant id 
        $("#FeaturedContentInner").attr("data-activevariantid", el.attr("data-variantid"));    

        // set title variant 
        $("#FeaturedContent #FeaturedContentTitle span").text(el.text()); 

        // set title price 
        $("#FeaturedContent #FeaturedContentPrice span.price").text(el.attr("data-variantprice")); 
        
        // handle discount cases 
        if (el.attr("data-variantdiscount").length > 0) {  
            if ($("#FeaturedContentPrice span.oldprice").length > 0) {
                $("#FeaturedContentPrice span.oldprice").text(el.attr("data-variantcompprice"));
            }
            else {
                $("#FeaturedContentPrice").prepend("<span class='oldprice'>" + el.attr("data-variantcompprice") + "</span>");
            }
            if ($("#FeaturedContentPrice span.discount").length > 0) {
                $("#FeaturedContentPrice span.discount").text(el.attr("data-variantdiscount") + "% OFF"); 

            }
            else { 
                $("#FeaturedContentPrice").append("<span class='discount'>" + el.attr("data-variantdiscount") + "% OFF</span>"); 
            } 
        } 
        else {
            $("#FeaturedContentPrice span.oldprice").remove();
            $("#FeaturedContentPrice span.discount").remove();
        }
        
        // handle sold out case 
        (el.attr("data-variantavailable") === "false") ? $("#FeaturedAdd").addClass("soldout").text("SOLD OUT") : $("#FeaturedAdd").removeClass("soldout").text("ADD TO CART");

        // set dd title text 
        $("#FeaturedContentVariantHeader h3 span").text(el.text());  

        // set active dd el 
        $("#VariantDropDown h5.active").removeClass("active");
        el.addClass("active");  

    });  
      



    // set initial variant as active (if variants exist) *** 
    if ($("#FeaturedContentVariants").length) {
        let initialVariantId = $("#FeaturedContentInner").attr("data-activevariantid");
        let initialVariantElement = $("#VariantDropDown h5[data-variantid='" + initialVariantId + "']");
        initialVariantElement.click();
    }




    // change item quantity ***  
    $("#FeaturedContentCheckoutArea .fqty").click(function() {  
        let qtySpan = $("#FeaturedQuantity span.qty"); 
        if ($(this).hasClass("plus")) {
            currentFeaturedQty++;
            qtySpan.text(currentFeaturedQty);  
        }
        if ($(this).hasClass("minus") && currentFeaturedQty > 1) { 
            currentFeaturedQty--;
            qtySpan.text(currentFeaturedQty);   
        } 
    });   




    // open or close dd *** 
    $("#FeaturedContent .fpc-header.dd").on("click", function () {
        const $header = $(this);
        setDropdownState($header, !$header.hasClass("active"));
    });




    // subscription dd press *** 
    $("#SubscriptionDropDown").on("click", "h5", function () {
        $("#SubscriptionDropDown h5.active").removeClass("active");
        $(this).addClass("active");
    });




    // one time purchase press *** 
    $("#OneTimePurchase").on("click", function () {
        const $subHeader = $("#SubscriptionDropDownHeader");
        if ($subHeader.hasClass("active")) {
            setDropdownState($subHeader, false);
        }
    });  




    // dd helper *** 
    function setDropdownState($header, open) {
        const ddNum = $header.data("fpcddnum");
        const $dd = $("#FeaturedContent .fpc-dd.fpcdd" + ddNum);
        const isSubscription = $header.hasClass("subscription");
        $header.toggleClass("active", open);
        $dd.toggleClass("active", open);
        if (isSubscription) {
            $("#OneTimePurchase").toggleClass("active", !open);
        }
    }










 
    // ******************************************************
    // FECTH + DISPLAY RELATED PRODUCTS                     
    // ******************************************************


    fetchRelatedProducts(); 
    async function fetchRelatedProducts() {




        // --- 1) init ---
        let thisProductId = $("#FeaturedProductRelatedItems").attr("data-parentproductid");
        let seen = [thisProductId];
        let recoResults = [];




        // --- 2) fetch recommendations ---
        let recoUrl = new URL(window.Shopify.routes.root + 'recommendations/products.json', location.origin);
        recoUrl.searchParams.set('product_id', thisProductId);
        recoUrl.searchParams.set('intent', 'related');
        recoUrl.searchParams.set('limit', '4');
        
        try { 
            let res = await fetch(recoUrl);
            let data = await res.json();
            if (data.products.length) {
                data.products.forEach(prod => {
                    if (!seen.includes(prod.id) && recoResults.length < 4) {
                        seen.push(prod.id);
                        recoResults.push(prod);
                    }
                });
            }
        } 
        catch(e) { console.log(e); }




        // --- 3) fallback to best sellers ---
        if (recoResults.length < 4) {
            
            let needed = 4 - recoResults.length; 
            let fallbackCollectionHandle = 'top-sellers';  
            let fallbackUrl = `/collections/${fallbackCollectionHandle}/products.json?limit=${needed}&sort_by=best-selling`;
            
            try {
                let res = await fetch(fallbackUrl);
                let data = await res.json(); 
                if (data.products.length) {
                    data.products.forEach(prod => {
                        if (!seen.includes(prod.id) && recoResults.length < 4) {
                            seen.push(prod.id);
                            recoResults.push(prod);
                        }
                    });
                } 
            } 
            catch(e) { console.log(e); }

        }


   

        // --- 4) render the results ---
        for (let k = 0; k < recoResults.length; k++) {

            let prod = recoResults[k];
            let variant = prod.variants[0]; 
            let compareAt = variant.compare_at_price; 
            let price = variant.price; 
            let vendor = prod.vendor; 
            let title = prod.title; 
            let variantTitle = (variant.title === 'Default Title') ? false : variant.title;  
            let img = prod.featured_image; 
            let url = "/products/" + prod.handle + "?variant=" + variant.id; 
            let available = variant.available; 
            let discount = (compareAt && compareAt > price) ? Math.round(((compareAt - price) / compareAt) * 100) : 0; 
            let shopCurrency = 'USD'; 

            $("#FeaturedProductRelatedItemsInner").prepend(
                `
                <div class="dds-product animation${k} ae-fadein ae-up">
                    <a class="dds-prodanchor" href="${url}">
                        <img class="dds-prodimg" src="${img}" loading="lazy">
                        <div class="dds-prodimgoverlay"></div>
                        <div class="dds-prodcont">
                            <h2>${vendor}</h2>
                            <h1>${title}${variantTitle ? ' — ' + variantTitle : ''}</h1>
                            ${
                                (compareAt && compareAt > price) 
                                    ? `
                                        <p class="dds-prodprice">
                                            <span class="dds-prodoldprice">${formatMoney(compareAt, shopCurrency)}</span>
                                            <span class="dds-prodsaleprice">${formatMoney(price, shopCurrency)}</span>
                                            <span class="dds-proddiscount">${discount}% Off</span>
                                        </p>
                                      `
                                    : `<p class="dds-prodprice">${formatMoney(price, shopCurrency)}</p>`
                            }
                        </div>
                    </a>
                    <div class="dds-prodcheckout">
                        <h2 class="dds-prodcheckoutqty" data-currentqty="1">
                            <span class="pcqtyadjust minus">-</span>
                            <span class="qty">1</span>
                            <span class="pcqtyadjust plus">+</span>
                        </h2>
                        ${
                            available
                                ? `<h2 class="dds-prodcheckoutadd pcinstock" data-variantid="${variant.id}">Add To Cart</h2>`
                                : `<h2 class="dds-prodcheckoutadd pcoutofstock">Out of Stock</h2>`
                        }
                    </div>
                    <div class="animation-element up-trigger" data-num="${k}"></div>
                </div>
                `
            );

        }


   

        // --- 5) format money ---
        function formatMoney(cents, currency) {
            if (cents == null) return '';
            return new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 2
            }).format(cents / 100);    
        }




    }











